import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import DataTable from 'react-data-table-component';
import { useAuth0 } from "@auth0/auth0-react";
import * as S from './Styles';
import Button from '@gymshark/button/dist/components/Link';
import { statusCheck } from 'utils/statusCheck';
import { useStores } from 'components/providers/Stores';
import { useConfig } from 'components/providers/Config';

import { columns } from './tableColumns';
import { Loader } from '../Loader';

const Jobs = () => {
    const Router = useRouter();
    const stores = useStores();
    const config = useConfig();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

    const fetchData = async () => {
        try {
            const accessToken = await getAccessTokenSilently();

            const res = await fetch(`${config.api.API_HOST}/jobs`, {
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            });

            if (statusCheck(res, Router, loginWithRedirect)) {
                const json = await res.json();
                return setData(json ?? []);
            }

            throw new Error('Failed to load jobs');
        } catch (error) {
            console.error(error);
            Router.push('/err');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [Router, getAccessTokenSilently]);

    return (
        <>
            <S.PageTitle>
                Product Jobs

                <Button buttonType="product" callback={() => Router.push('/jobs/new')}>
                    Add new product job
                </Button>
            </S.PageTitle>

            <DataTable
                // @ts-expect-error
                columns={columns(stores)}
                data={data}
                progressPending={loading}
                striped={true}
                noHeader={true}
                progressComponent={<Loader />}
            />
        </>
    );
};

export { Jobs }
